import { useDrag } from 'react-dnd';
import { TaskSection } from '../interfaces/Task';
import { useRef } from 'react';

interface DraggableSectionProps {
    section: TaskSection;
    children: (dragHandleRef: any) => React.ReactNode;
}

export default function DraggableSection(props: DraggableSectionProps) {
    const dragHandleRef = useRef<HTMLDivElement>(null);

    const [{ isDragging }, drag, preview] = useDrag(() => ({
        type: 'section',
        item: {
            sectionId: props.section._id,
            section: props.section
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    }), [props.section._id]);

    // Connect the drag handle
    drag(dragHandleRef);

    return (
        <div
            ref={preview as any}
            style={{
                opacity: isDragging ? 0.5 : 1,
                position: 'relative'
            }}
        >
            {props.children(dragHandleRef)}
        </div>
    );
}
